import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addBeforeRegistrationHook } from '../store/actions';

export const useAddBeforeRegistrationHook = () => {
    const dispatch = useDispatch();

    return useCallback((callback) => {
        dispatch(addBeforeRegistrationHook(callback));
    }, [dispatch]);
};
